import { cn } from '../../utils/cn';

const TONES = {
  info: 'bg-blue-50 border-blue-200 text-blue-800',
  success: 'bg-emerald-50 border-emerald-200 text-emerald-800',
  warning: 'bg-amber-50 border-amber-200 text-amber-800',
  danger: 'bg-red-50 border-red-200 text-red-800',
};

export default function Notice({ tone = 'info', title, children, action, className }) {
  return (
    <div className={cn('rounded-xl border px-4 py-3 flex flex-col sm:flex-row sm:items-center gap-3', TONES[tone], className)}>
      <div className="flex-1 min-w-0">
        {title && <p className="text-sm font-semibold">{title}</p>}
        {children && <div className={cn('text-xs leading-relaxed', title && 'mt-0.5 opacity-90')}>{children}</div>}
      </div>
      {action}
    </div>
  );
}
